(function() {
  define('tlhComponentsEditableLink',['angular', 'angularBootstrap', 'angularAnimate'], function() {
    'use strict';
    return angular.module('tlhComponentsEditableLink', ['ngAnimate']).directive('tlhEditableLink', [
      '$uibModal', function($uibModal) {
        return {
          restrict: 'A',
          scope: {
            link: '<datasource',
            withText: '<',
            withTitle: '<',
            withTarget: '<',
            fullLink: '<'
          },
          link: function(scope, element) {
            return element.on('click', function() {
              var modal;
              modal = $uibModal.open({
                templateUrl: '/assets/lib/angular/tlh/components/editableLinkModal.html',
                resolve: {
                  data: {
                    link: scope.link,
                    withText: !!scope.withText,
                    withTitle: !!scope.withTitle,
                    withTarget: !!scope.withTarget,
                    fullLink: !!scope.fullLink
                  }
                },
                controllerAs: '$ctrl',
                bindToController: true,
                controller: [
                  '$uibModalInstance', 'data', function($uibModalInstance, data) {
                    var mvm;
                    mvm = this;
                    mvm.data = data;
                    mvm.ok = function() {
                      var result;
                      result = {
                        success: true,
                        link: mvm.data.link
                      };
                      return $uibModalInstance.close(result);
                    };
                    mvm.cancel = function() {
                      return $uibModalInstance.dismiss('cancel');
                    };
                  }
                ]
              });
              return modal.result.then(function(result) {
                if (result.success && result.link) {
                  if (scope.link == null) {
                    scope.link = {};
                  }
                  scope.link.url = result.link.url;
                  scope.link.text = result.link.text;
                  scope.link.title = result.link.title;
                  return scope.link.targetBlank = result.link.targetBlank;
                }
              });
            });
          }
        };
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=editableLink.js.map
;
